"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACTION_LINK_ICON_NAME", {
  enumerable: true,
  get: function () {
    return _Icon.ICON_NAME;
  }
});
exports.ACTION_LINK_ICON_POSITION = void 0;
Object.defineProperty(exports, "ACTION_LINK_ICON_SIZE", {
  enumerable: true,
  get: function () {
    return _Icon.ICON_SIZE;
  }
});
exports.ACTION_LINK_THEME = exports.ACTION_LINK_TARGET = void 0;
var _Icon = require("b2b-components/theme/components/Icon");
let ACTION_LINK_ICON_POSITION = exports.ACTION_LINK_ICON_POSITION = /*#__PURE__*/function (ACTION_LINK_ICON_POSITION) {
  ACTION_LINK_ICON_POSITION["left"] = "left";
  ACTION_LINK_ICON_POSITION["right"] = "right";
  return ACTION_LINK_ICON_POSITION;
}({});
let ACTION_LINK_THEME = exports.ACTION_LINK_THEME = /*#__PURE__*/function (ACTION_LINK_THEME) {
  ACTION_LINK_THEME["default"] = "default";
  ACTION_LINK_THEME["dark"] = "dark";
  return ACTION_LINK_THEME;
}({});
let ACTION_LINK_TARGET = exports.ACTION_LINK_TARGET = /*#__PURE__*/function (ACTION_LINK_TARGET) {
  ACTION_LINK_TARGET["self"] = "_self";
  ACTION_LINK_TARGET["blank"] = "_blank";
  ACTION_LINK_TARGET["parent"] = "_parent";
  ACTION_LINK_TARGET["top"] = "_top";
  return ACTION_LINK_TARGET;
}({});
//# sourceMappingURL=ActionLink.types.js.map